import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-custom-chip',
  templateUrl: './custom-chip.component.html',
  styleUrls: ['./custom-chip.component.scss'],
  standalone: true,
  imports: [ChipModule, TooltipModule]
})
export class CustomChipComponent {

  private readonly router = inject(Router);

  @Input() label: string = "";
  @Input() link?: string | any[] | null;
  @Input() openInNewTab: boolean = true;
  @Input() tooltip?: string = "";

  get isLink(): boolean {
    return this.link != null && this.link !== '';
  }

  onClick() {
    if (!this.isLink) {
      return;
    }
    const commands = Array.isArray(this.link) ? this.link : [this.link];
    if (this.openInNewTab) {
      const url = this.router.serializeUrl(this.router.createUrlTree(commands));
      window.open(url, '_blank');
    } else {
      this.router.navigate(commands);
    }
  }
}
